import React from 'react';
import { Button } from '../ui/button';
import { ChevronRight, X, Home } from 'lucide-react';
import type { ClusterSummary } from '../../types/journeys';

interface PathBreadcrumbsProps {
  path: ClusterSummary[];
  onNavigate: (index: number) => void;
  onClear: () => void;
}

export default function PathBreadcrumbs({
  path,
  onNavigate,
  onClear,
}: PathBreadcrumbsProps) {
  if (path.length === 0) {
    return null;
  }

  return (
    <div className="flex items-center gap-2 p-3 bg-gray-50 rounded-lg border">
      <div className="flex items-center gap-1 text-sm text-gray-500">
        <Home className="h-4 w-4" />
        <span>Path:</span>
      </div>
      <div className="flex items-center flex-wrap gap-1">
        {path.map((cluster, index) => (
          <React.Fragment key={`${cluster.id}-${index}`}>
            <Button
              variant={index === path.length - 1 ? 'default' : 'outline'}
              size="sm"
              className="h-7 px-2 text-xs"
              onClick={() => onNavigate(index)}
            >
              {cluster.label}
            </Button>
            {index < path.length - 1 && (
              <ChevronRight className="h-4 w-4 text-gray-400" />
            )}
          </React.Fragment>
        ))}
      </div>
      <Button
        variant="ghost"
        size="sm"
        className="h-7 px-2 ml-auto text-gray-500 hover:text-gray-700"
        onClick={onClear}
      >
        <X className="h-3 w-3 mr-1" />
        Clear
      </Button>
    </div>
  );
}
